module.exports = __webpack_public_path__ + "img/tutorial-f01-02.a3dec727.png";